// extracted by mini-css-extract-plugin
export default {"auftragsnummer":"BescheidModal_auftragsnummer__CvX+Q","grey":"BescheidModal_grey__S-wre"};